module.exports = __webpack_public_path__ + "static/media/biponon.f85a6574.svg";